import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadingStrategy, Route } from '@angular/router';
import { LoginComponent } from './screens/authentications/login/login.component';
import { PublicLayoutComponent } from './shared/public-layout/public-layout.component';
import { PrivateLayoutComponent } from './shared/private-layout/private-layout.component';
import { AuthGuard } from './services/auth.guard';
import { SignUpComponent } from './screens/authentications/sign-up/sign-up.component';
import { ForgotPasswordComponent } from './screens/authentications/forgot-password/forgot-password.component';

import { DatetestComponent } from './datetest/datetest.component';

import { SharedConstants } from './user-management/shared/models/shared-constants';
import { Observable, of } from 'rxjs';
import { ConfirmEmailComponent } from './static/confirm-email/confirm-email.component';
class CustomPreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    return route.data && route.data.preload ? load() : of(null);
  }
}

const routes: Routes = [
  // Private layout
  {
    path: '',
    runGuardsAndResolvers: 'always',
    component: PrivateLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'logout', component: LoginComponent },
      {
        path: 'Home',
        loadChildren: () =>
          import('./screens/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'user-access',
        loadChildren: () =>
          import('./user-management/user-access-management.module').then((m) => m.UserManagementModule),
      },

    ],
  },
  // Public layout
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      { path: 'login', component: LoginComponent },
      { path: 'signup', component: SignUpComponent },
      { path: 'forgotpassword', component: ForgotPasswordComponent },
      { path: '', component: LoginComponent },
      {
        path: SharedConstants.ACCOUNT + '/' + SharedConstants.CONFIRM_EMAIL,
        component: ConfirmEmailComponent
      },
      { path: 'date', component: DatetestComponent },
    ],
  },
  { path: '**', redirectTo: 'Home' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy',preloadingStrategy: CustomPreloadingStrategy })],
  exports: [RouterModule],
  providers: [CustomPreloadingStrategy]
})
export class AppRoutingModule { }
